import * as React from 'react';
import { Textarea } from '@/components/ui/textarea';
import type { StringDataType, UserDefinedType } from '@glueapp/graph-types';

interface StringValueEditorProps {
    type: StringDataType;
    value: string;
    userDefinedType?: UserDefinedType;
    onChange: (value: string, updatedType?: UserDefinedType) => void;
}

export const StringValueEditor: React.FC<StringValueEditorProps> = ({ type, value, onChange }) => {
    return (
        <div className="flex flex-col pt-1">
            <Textarea placeholder="Text" value={value} onChange={e => onChange(e.target.value)} className="min-h-6 p-1 resize-y" />
        </div>
    );
};
